// contexts/UIContext.js
import React, { createContext, useContext, useState } from "react";

const UIContext = createContext();

export const UIProvider = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBackdropVisible, setIsBackdropVisible] = useState(false);
  const [modalContent, setModalContent] = useState(null); // Store modal content

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
    setIsBackdropVisible(!isSidebarOpen || isModalOpen);
  };

  const openModal = (content) => {
    setModalContent(content); // Set modal content dynamically
    setIsModalOpen(true);
    setIsBackdropVisible(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalContent(null); // Clear modal content on close
    setIsBackdropVisible(isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
    setIsBackdropVisible(isModalOpen);
  };

  return (
    <UIContext.Provider
      value={{
        isSidebarOpen,
        isModalOpen,
        isBackdropVisible,
        modalContent, // Expose modal content
        toggleSidebar,
        openModal,
        closeModal,
        closeSidebar,
      }}
    >
      {children}
    </UIContext.Provider>
  );
};

export const useUIContext = () => useContext(UIContext);

// // contexts/UIContext.js
// import React, { createContext, useContext, useState } from "react";

// const UIContext = createContext();

// export const UIProvider = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBackdropVisible, setIsBackdropVisible] = useState(false);
//   const [modalContent, setModalContent] = useState(null); // Store modal content

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => !prev);
//     setIsBackdropVisible(!isSidebarOpen || isModalOpen);
//   };

//   const openModal = (content) => {
//     setModalContent(content); // Dynamically set modal content
//     setIsModalOpen(true);
//     setIsBackdropVisible(true);
//   };

//   const closeModal = () => {
//     setModalContent(null); // Clear modal content on close
//     setIsModalOpen(false);
//     setIsBackdropVisible(isSidebarOpen);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     setIsBackdropVisible(isModalOpen);
//   };

//   return (
//     <UIContext.Provider
//       value={{
//         isSidebarOpen,
//         isModalOpen,
//         isBackdropVisible,
//         modalContent,
//         toggleSidebar,
//         openModal,
//         closeModal,
//         closeSidebar,
//       }}
//     >
//       {children}
//     </UIContext.Provider>
//   );
// };

// export const useUIContext = () => useContext(UIContext);

// UI CONTEXT BEFORE MODAL IMPLEMENTATION - HEADER & SIDEBAR WORKING
// // contexts/UIContext.js
// import React, { createContext, useContext, useState } from "react";

// const UIContext = createContext();

// export const UIProvider = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBackdropVisible, setIsBackdropVisible] = useState(false);

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prev) => !prev);
//     setIsBackdropVisible(!isSidebarOpen || isModalOpen);
//   };

//   const openModal = () => {
//     setIsModalOpen(true);
//     setIsBackdropVisible(true);
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setIsBackdropVisible(isSidebarOpen);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     setIsBackdropVisible(isModalOpen);
//   };

//   return (
//     <UIContext.Provider
//       value={{
//         isSidebarOpen,
//         isModalOpen,
//         isBackdropVisible,
//         toggleSidebar,
//         openModal,
//         closeModal,
//         closeSidebar,
//       }}
//     >
//       {children}
//     </UIContext.Provider>
//   );
// };

// export const useUIContext = () => useContext(UIContext);

// import React, { createContext, useContext, useState } from "react";

// const UIContext = createContext();

// export const UIProvider = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [isBackdropVisible, setIsBackdropVisible] = useState(false);
//   const [modalContent, setModalContent] = useState(null); // Define modal content state

//   const toggleSidebar = () => {
//     setIsSidebarOpen((prevState) => {
//       const newSidebarState = !prevState; // Toggle the sidebar state
//       setIsBackdropVisible(newSidebarState || isModalOpen); // Show backdrop only if sidebar or modal is open
//       return newSidebarState;
//     });
//   };

//   const openModal = (content) => {
//     setModalContent(content); // Store the component or JSX to render inside the modal
//     setIsModalOpen(true); // Open the modal
//     setIsBackdropVisible(true); // Show the backdrop
//   };

//   const closeModal = () => {
//     setIsModalOpen(false);
//     setModalContent(null); // Clear the modal content when closed
//     setIsBackdropVisible(isSidebarOpen);
//   };

//   const closeSidebar = () => {
//     setIsSidebarOpen(false);
//     setIsBackdropVisible(isModalOpen);
//   };

//   return (
//     <UIContext.Provider
//       value={{
//         isSidebarOpen,
//         isModalOpen,
//         isBackdropVisible,
//         modalContent, // Provide modal content to consumers
//         toggleSidebar,
//         openModal,
//         closeModal,
//         closeSidebar,
//       }}
//     >
//       {children}
//     </UIContext.Provider>
//   );
// };

// export const useUIContext = () => useContext(UIContext);
